var React = require('react');

function Pdf (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M20.25 14.983H18v1.497h1.5a.749.749 0 1 1 0 1.497H18v2.244a.749.749 0 0 1-1.5 0v-5.986c0-.412.335-.748.75-.748h3a.749.749 0 1 1 0 1.496zM6 20.97a.749.749 0 0 1-.75-.748v-5.987c0-.412.335-.748.75-.748h1.5c1.262 0 2.25 1.143 2.25 2.603 0 1.442-.979 2.599-2.228 2.634H6.75v1.497a.749.749 0 0 1-.75.749zm1.5-3.742c.358-.01.75-.44.75-1.138 0-.692-.382-1.107-.75-1.107h-.75v2.245h.75zm3.75 3.742a.749.749 0 0 1-.75-.748v-5.987c0-.412.335-.748.75-.748h1.573a2.927 2.927 0 0 1 2.927 2.92v1.642c0 1.61-1.313 2.921-2.927 2.921H11.25zm3-2.92v-1.643c0-.784-.64-1.424-1.427-1.424H12v4.49h.823c.787 0 1.427-.638 1.427-1.424zM18 11.241a.749.749 0 0 1-.75.748.749.749 0 0 1-.75-.748V8.249h-6a.75.75 0 0 1-.75-.749V1.478H1.5v20.97l15.75.018a.749.749 0 1 1 0 1.497H1.519C.68 23.963 0 23.283 0 22.448V1.533C0 .698.681.017 1.519.017H10.5c.018 0 .033.01.05.01a.753.753 0 0 1 .191.039c.026.009.052.015.075.027.076.035.148.08.21.141l.005.004 6.668 6.651c.023.018.035.046.057.066.022.02.038.043.058.066.116.132.2.29.2.479 0 .026-.012.047-.014.073v3.669zm-6.75-8.67v4.18h4.19l-4.19-4.18z"}));
}

Pdf.displayName = "Pdf";

Pdf.defaultProps = {"viewBox":"0 0 21 24"};

module.exports = Pdf;

Pdf.default = Pdf;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/pdf.svg
// module id = 1280
// module chunks = 0